import * as Yup from 'yup';
import moment from 'moment';

import { getTranslatedString } from 'helpers/i18n';

export const validateLeaseIncentiveForm = (selectedLeaseStartDate, selectedEarlyMoveInDate) => {
  return Yup.object().shape({
    start_date: Yup.string()
      .required(
        getTranslatedString('landlordPortal.leaseCreatorV2.leaseIncentivesPage.startDateIsRequired')
      )
      .test(
        'start_date',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseIncentivesPage.startDateCannotBeBefore'
        ),
        value => {
          if (!value) return false;
          return (
            !moment(value).isBefore(selectedLeaseStartDate) ||
            !moment(value).isBefore(selectedEarlyMoveInDate)
          );
        }
      ),
    duration: Yup.string().required(
      getTranslatedString('landlordPortal.leaseCreatorV2.leaseIncentivesPage.durationIsRequired')
    ),
    monthly_discount: Yup.number()
      .typeError()
      .required(
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseIncentivesPage.monthlyDiscountIsRequired'
        )
      )
      .test(
        'monthly_discount',
        getTranslatedString(
          'landlordPortal.leaseCreatorV2.leaseIncentivesPage.monthlyDiscountCannotBeNegative'
        ),
        value => {
          if (value === undefined) return false;
          return value >= 0;
        }
      ),
  });
};
